export const LIBRARY_BACKUP_FORMAT = "runner-forge-library-backup";
export const LIBRARY_BACKUP_VERSION = 1;
export const MAX_BACKUP_CHARACTERS = 500;

const isObject = (value) => Boolean(value) && typeof value === "object" && !Array.isArray(value);

export const createLibraryBackup = ({ appVersion, characters, createdAt = new Date().toISOString() }) => {
  if (!Array.isArray(characters)) throw new Error("A library backup requires a character list.");
  if (characters.length > MAX_BACKUP_CHARACTERS) throw new Error(`A library backup can contain at most ${MAX_BACKUP_CHARACTERS} characters.`);
  if (!characters.every(isObject)) throw new Error("Every library backup entry must be a character build.");
  if (!Number.isFinite(Date.parse(createdAt))) throw new Error("A library backup requires a valid creation time.");
  return {
    format: LIBRARY_BACKUP_FORMAT,
    backupVersion: LIBRARY_BACKUP_VERSION,
    appVersion: typeof appVersion === "string" ? appVersion : "unknown",
    createdAt,
    characterCount: characters.length,
    characters,
  };
};

export const parseLibraryBackup = (value) => {
  if (!isObject(value) || value.format !== LIBRARY_BACKUP_FORMAT) return null;
  const version = Number(value.backupVersion);
  if (version > LIBRARY_BACKUP_VERSION) throw new Error("This library backup was created by a newer version of Runner Forge.");
  if (version !== LIBRARY_BACKUP_VERSION) throw new Error("That library backup has an unsupported format version.");
  if (!Array.isArray(value.characters)) throw new Error("That library backup does not contain a character list.");
  if (value.characters.length > MAX_BACKUP_CHARACTERS) throw new Error(`Library backups are limited to ${MAX_BACKUP_CHARACTERS} characters.`);
  if (Number(value.characterCount) !== value.characters.length) throw new Error("That library backup appears incomplete or damaged.");
  if (!Number.isFinite(Date.parse(value.createdAt))) throw new Error("That library backup is missing a valid creation time.");
  return {
    backupVersion: version,
    appVersion: typeof value.appVersion === "string" ? value.appVersion : "unknown",
    createdAt: value.createdAt,
    characters: value.characters,
  };
};

export const libraryBackupFilename = (createdAt) => {
  const timestamp = Number.isFinite(Date.parse(createdAt)) ? new Date(createdAt).toISOString() : new Date().toISOString();
  return `runner-forge-library-${timestamp.replace(/[:.]/g, "-")}.json`;
};
